import { render, staticRenderFns } from "./TreasurePage.vue?vue&type=template&id=8a8dda70&scoped=true"
import script from "./TreasurePage.vue?vue&type=script&lang=js"
export * from "./TreasurePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a8dda70",
  null
  
)

export default component.exports